import { html, css } from '@design.estate/dees-element';

export const demoFunc = () => html`
  <dees-demowrapper>
    <style>
      ${css`
        .demo-container {
          display: flex;
          flex-direction: column;
          gap: 24px;
          padding: 24px;
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .payment-group {
          display: flex;
          align-items: center;
          gap: 16px;
          flex-wrap: wrap;
        }
      `}
    </style>
    
    <div class="demo-container">
      <dees-panel .title=${'Basic IBAN Input'} .subtitle=${'International Bank Account Number with automatic formatting'}>
        <dees-form>
          <dees-input-iban
            .label=${'Bank Account IBAN'}
            .infoText=${'Enter your International Bank Account Number'}
            .description=${'Your IBAN can be found on your bank statement'}
          ></dees-input-iban>

          <dees-input-iban
            .label=${'Verified IBAN'}
            .infoText=${'This IBAN has been verified'}
            .value=${'DE89370400440532013000'}
          ></dees-input-iban>
        </dees-form>
      </dees-panel>
      
      <dees-panel .title=${'Payment Information'} .subtitle=${'IBAN input with horizontal layout for payment forms'}>
        <dees-form>
          <div class="payment-group">
            <dees-input-text
              .label=${'Account Holder'}
              .layoutMode=${'horizontal'}
              .value=${'John Doe'}
            ></dees-input-text>

            <dees-input-iban
              .label=${'IBAN'}
              .layoutMode=${'horizontal'}
              .value=${'GB82WEST12345698765432'}
            ></dees-input-iban>
          </div>
        </dees-form>
      </dees-panel>
      
      <dees-panel .title=${'Validation & States'} .subtitle=${'Required fields and disabled states'}>
        <dees-form>
          <dees-input-iban
            .label=${'Payment Account'}
            .infoText=${'Required for processing payments'}
            .required=${true}
          ></dees-input-iban>

          <dees-input-iban
            .label=${'Locked IBAN'}
            .infoText=${'This IBAN cannot be changed'}
            .value=${'FR1420041010050500013M02606'}
            .disabled=${true}
          ></dees-input-iban>
        </dees-form>
      </dees-panel>
      
      <dees-panel .title=${'Bank Transfer Form'} .subtitle=${'Complete form example with IBAN validation'}>
        <dees-form>
          <dees-input-text .label=${'Recipient Name'} .required=${true}></dees-input-text>
          <dees-input-iban .label=${'Recipient IBAN'} .required=${true}></dees-input-iban>
          <dees-input-text .label=${'Transfer Reference'} .infoText=${'Optional reference for the transfer'}></dees-input-text>
          <dees-input-text .label=${'Amount'} .inputType=${'number'} .required=${true}></dees-input-text>
        </dees-form>
      </dees-panel>
    </div>
  </dees-demowrapper>
`;